let itemComponent: ReturnType<typeof importItemComponent> | undefined;

function importItemComponent() {
  return import('./item.component');
}

export function loadItemComponent() {
  itemComponent ??= importItemComponent();
  return itemComponent;
}

export function preloadItemComponent(): void {
  void loadItemComponent();
}
